export default "/static/webpack/images/blog/colors.jpg";